import { Box } from "@/components/ui/box";
import { Fab, FabIcon, FabLabel } from "@/components/ui/fab";
import { FlatList } from "@/components/ui/flat-list";
import { Pressable } from "@/components/ui/pressable";
import { Spinner } from "@/components/ui/spinner";
import { VStack } from "@/components/ui/vstack";
import { useOrgWalletControllerList } from "@/generated/api/api";
import { WalletDTO } from "@/generated/api/models";
import { EmptyState } from "@/screens/common/empty.state";
import { RestaurantWalletActionSheet } from "@/screens/restaurants/details/restaurant.wallet.action.sheet";
import { RestaurantWalletItemFull } from "@/screens/restaurants/details/restaurant.wallet.item";
import { RestaurantWalletModalCreate } from "@/screens/restaurants/details/restaurant.wallet.modal";
import { Stack, useLocalSearchParams } from "expo-router";
import { Plus } from "lucide-react-native";
import { useState } from "react";

export default function RestaurantWalletListFull() {
  const { orgId } = useLocalSearchParams<{ orgId: string }>();

  const {
    data: wallets,
    isLoadingError,
    refetch,
    isRefetching,
  } = useOrgWalletControllerList(orgId);

  const [showCreationModal, setShowCreationModal] = useState(false);
  const [sheetIsOpen, setSheetIsOpen] = useState(false);
  const [sheetWallet, setSheetWallet] = useState<WalletDTO>();

  return (
    <>
      <Stack.Screen options={{ title: "Wallets" }} />
      <FlatList
        className="w-full h-full"
        contentContainerClassName="grow gap-4 p-4"
        data={wallets}
        keyExtractor={(info) => info.id}
        renderItem={(info) => {
          return (
            <Pressable
              className="w-full"
              onPress={() => {
                setSheetWallet(info.item);
                setSheetIsOpen(true);
              }}
            >
              <RestaurantWalletItemFull wallet={info.item} />
            </Pressable>
          );
        }}
        refreshing={isRefetching}
        onRefresh={refetch}
        showsHorizontalScrollIndicator={false}
        showsVerticalScrollIndicator={false}
        ListEmptyComponent={() => (
          <VStack className="h-full w-full p-3">
            {wallets?.length === 0 ? (
              <EmptyState title="No wallets" />
            ) : isLoadingError ? (
              <EmptyState
                title="Something went wrong"
                description="Please check your internet connection and try again"
              />
            ) : (
              <Spinner size="large" />
            )}
          </VStack>
        )}
      />
      <RestaurantWalletModalCreate
        organizationId={orgId}
        isOpen={showCreationModal}
        onClose={() => setShowCreationModal(false)}
      />
      <Fab
        size="md"
        placement="bottom right"
        isHovered={false}
        isDisabled={false}
        isPressed={false}
        onPress={() => setShowCreationModal(true)}
      >
        <FabIcon as={Plus} />
        <FabLabel>Create</FabLabel>
      </Fab>
      <RestaurantWalletActionSheet
        wallet={sheetWallet}
        isOpen={sheetIsOpen}
        onClose={() => setSheetIsOpen(false)}
        organizationId={orgId}
      />
    </>
  );
}
